module.exports = __webpack_public_path__ + "static/images/finance-6.cfb9fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/finance-6.png
// module id = mxrZ
// module chunks = 8